import {Inject, Pipe, PipeTransform} from '@angular/core';
import * as _ from "lodash";
import {TranslateService} from '@ngx-translate/core';
import {getMetersPerLargeDistanceUnit} from '../../utils/distance-unit.util';


@Pipe({
  standalone: false,
  name: 'bringozDistance'
})

export class BringozDistancePipe implements PipeTransform {

  private metersPerUnit: number;
  private distanceConfig: any;

  constructor(@Inject('splitService') private splitService, @Inject(TranslateService) private translateService: TranslateService) {
    // Initialize factor based on distance configuration from SplitService
    this.distanceConfig = this.splitService.getSiteDistanceLargeUnit(true);
    this.metersPerUnit = getMetersPerLargeDistanceUnit(this.distanceConfig === 'MI');
  }

  transform(distanceInMeters: number, defaultValue: string = '---', showUnit?: boolean, decimals: number = 2): string {
    if (!_.isUndefined(distanceInMeters)) {
      return `${(distanceInMeters / this.metersPerUnit).toFixed(decimals).toString()} ${showUnit ? this.translateService.instant(this.distanceConfig) : ''}`;
    } else {
      return defaultValue;
    }
  }
}
